<template>
  <div>
    <ts-page-title
      :title="$t('setupOurFarmers.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        { text: $t('setupOurFarmers.pageTitle'), active: true }
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper class="ts-flex ts-items-center ts-justify-between">
        <Button type="info" ghost @click="addNew">{{
          $t('Add New')
        }}</Button>
        <div class="ts-space-x-2">
          <Input
            search
            v-model="search"
            :placeholder="$t('setupOurFarmers.search')"
            :style="width"
            @on-focus="() => (width = 'width : 500px')"
            @on-blur="() => (width = 'width  : 300px')"
          />
        </div>
      </ts-panel-wrapper>
      <Table
        :columns="columns"
        :data="resources"
        size="small"
        :loading="loading"
        highlight-row
        stripe
        max-height="700"
      >
        <template slot-scope="{ row }" slot="photo">
          <img
            class="ts-rounded ts-w-8"
            v-if="row.employee"
            v-lazy="{
              src: photo(row.employee),
              error:
                row.employee.sex == 'Male'
                  ? require('@/assets/staff-default-man.png')
                  : require('@/assets/staff-default-women.png'),
              loading: require('@/assets/Rolling-1s-200px.svg'),
              preLoad: 1.3,
              attempt: 1
            }"
          />
        </template>

        <template slot-scope="{ row }" slot="employee">{{
          row.employee ? row.employee.employee_name_en : ''
        }}</template>

        <template slot-scope="{ row }" slot="sex">{{
          row.employee ? row.employee.sex : ''
        }}</template>

        <template slot-scope="{ row }" slot="position">{{
          row.employee.logical_position.position_name_en
        }}</template>

        <template slot-scope="{ row }" slot="actions">
          <a
            href="#"
            class="text-primary"
            @click.prevent="onEdit(row)"
            v-tooltip="$t('edit')"
          >
            <Icon type="ios-create" size="20" />
          </a>
          <Poptip
            confirm
            :title="$t('areYouSure')"
            @on-ok="onDelete(row)"
            :transfer="true"
            :ok-text="$t('yes')"
            :cancel-text="$t('no')"
          >
            <a
              class="text-danger"
              v-tooltip="$t('delete')"
              :disabled="row._deleting"
            >
              <i class="fas fa-circle-notch fa-spin" v-if="row._deleting"> </i>
              <Icon type="ios-trash" size="20" v-else />
            </a>
          </Poptip>
        </template>
      </Table>
      <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
        <ts-i-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-i-pagination>
      </div>

      <a-modal
        v-model="showForm"
        v-if="showForm"
        draggable
        sticky
        scrollable
        :mask="false"
        :footer="null"
        :z-index="1022"
        :closable="true"
        :title="$t('setupOurFarmers.pageTitle')"
      >
        <from-action
          ref="form_action"
          @cancel="clearEdit"
          @fetchData="fetchData"
        />
      </a-modal>
    </ts-panel>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FromAction from './form.vue'
import { debounce } from 'lodash'

export default {
  name: 'setup-our-farmersIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false,
      width: 'width: 300px'
    }
  },
  computed: {
    ...mapState('website/setupOurFarmers', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.website.setupOurFarmers.search
      },
      set(newValue) {
        this.$store.commit('website/setupOurFarmers/SET_SEARCH', newValue),
          this.$store.commit('website/setupOurFarmers/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          title: this.$t('setupOurFarmers.photo'),
          slot: 'photo',
          width: 80
        },
        {
          title: this.$t('setupOurFarmers.employeeName'),
          slot: 'employee',
          width: 170
        },
        {
          title: this.$t('setupOurFarmers.employeeSex'),
          slot: 'sex',
          width: 80
        },
        {
          title: this.$t('setupOurFarmers.employeePosition'),
          slot: 'position',
          width: 150
        },

        {
          title: this.$t('setupOurFarmers.facebook'),
          key: 'facebook_url',
          width: 230
        },

        {
          title: this.$t('setupOurFarmers.telegram'),
          key: 'telegram_url',
          width: 230
        },

        {
          title: this.$t('setupOurFarmers.linkedin'),
          key: 'linkedin_url',
          width: 230
        },

        {
          title: this.$t('actions'),
          slot: 'actions',
          fixed: 'right',
          align: 'center',
          width: 90
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('website/setupOurFarmers/fetch', {
          ...attributes
        })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.$store.commit('website/setupOurFarmers/SET_EDIT_DATA', {})
      this.showForm = true
    },
    onEdit(record) {
      this.$store.commit('website/setupOurFarmers/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit() {
      this.showForm = false
      this.$store.commit('website/setupOurFarmers/SET_EDIT_DATA', {})
    },
    onDelete(record) {
      record._deleting = true
      this.$store
        .dispatch('website/setupOurFarmers/destroy', record.id)
        .then(response => {
          record._deleting = false
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          record._deleting = false
          this.$toasted.error(error.message)
        })
    },
    photo(record) {
      if (record.photo) {
        return record.photo
      }

      return record.sex == 'Male'
        ? require('@/assets/staff-default-man.png')
        : require('@/assets/staff-default-women.png')
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('website/setupOurFarmers/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
